import { Pipe, PipeTransform } from "@angular/core";

import { Domain as ProductDomain } from "../../../lib/Domain/Product";

@Pipe({
  name: "productType"
})
export class ProductTypePipe implements PipeTransform {
  protected static pipeMap = new Map<ProductDomain.ProductType, string>();
  constructor() {
    // 參考\lib\Domain\index.ts ProductType
    ProductTypePipe.pipeMap.set(ProductDomain.ProductType.SmartPanel, "智慧配電盤");
    ProductTypePipe.pipeMap.set(ProductDomain.ProductType.SmartCB, "智慧監測迴路");
    ProductTypePipe.pipeMap.set(ProductDomain.ProductType.SmartPlug, "智慧插座");
    ProductTypePipe.pipeMap.set(ProductDomain.ProductType.EnergyStrogeSystem, "儲能系統");
    ProductTypePipe.pipeMap.set(ProductDomain.ProductType.WSN, "空氣檢測");
  }
  transform(value: any, args?: any): any {
    try {
      return ProductTypePipe.pipeMap.get(value);
    } catch (erro) {
      return `未知${value}`;
    }
  }
  public static getType(): any[] {
    let array: any[] = [];
    ProductTypePipe.pipeMap.forEach((v, k) => {
      array.push({ n: v, v: k });
    });
    return array;
  }
  public static deviceNO2Type(value: string): ProductDomain.ProductType {
    return <ProductDomain.ProductType>value.toUpperCase();
  }

}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/product-type.pipe.ts